export default function prettifyString(str) {
  if (!str) return "";

  // Replace underscores or hyphens with spaces
  const normalized = str.replace(/[_-]+/g, " ");

  // Split into words, capitalize first letter of each, then join
  const prettified = normalized
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return prettified;
}